import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      spacing={{ xs: 1, sm: 1.5 }}
      sx={{ mb: { xs: 1, md: 1.5 } }}
      className="page-header-actions page-enter"
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            lineHeight: 1.2,
            letterSpacing: '-0.025em',
            fontSize: { xs: '1.05rem', sm: '1.15rem', md: '1.25rem' },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: { xs: 'normal', sm: 'nowrap' },
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, letterSpacing: '-0.005em', lineHeight: 1.5 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions && (
        <Stack
          direction="row"
          spacing={1}
          flexWrap="wrap"
          sx={{ flexShrink: 0, '& .MuiButton-root': { whiteSpace: 'nowrap' } }}
        >
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
